(function () {
  let lastColor = null;

  let colorTimer = null;

  let retryTimer = null;

  function getColorFromVariantPicker() {
    const checked = document.querySelector(
      'input[data-option-name="颜色"]:checked',
    );

    if (checked) {
      return checked.value;
    }

    const inputs = document.querySelectorAll('input[type="radio"]:checked');

    for (const input of inputs) {
      const name = (input.dataset.optionName || "").toLowerCase();

      if (
        name.includes("color") ||
        name.includes("colour") ||
        name.includes("颜色")
      ) {
        return input.value;
      }
    }

    return null;
  }

  function focusColorMedia(color) {
    if (!color) {
      return false;
    }

    const thumbnail = document.querySelector(
      `.slideshow-controls__thumbnail[data-media-color="${CSS.escape(color)}"]`,
    );

    if (!thumbnail) {
      return false;
    }

    thumbnail.click();

    return true;
  }

  function waitAndFocusColor(color) {
    let attempts = 0;

    if (retryTimer) {
      clearInterval(retryTimer);

      retryTimer = null;
    }

    retryTimer = setInterval(function () {
      attempts++;

      const success = focusColorMedia(color);

      if (success || attempts >= 15) {
        clearInterval(retryTimer);

        retryTimer = null;
      }
    }, 200);
  }

  document.addEventListener("change", function (e) {
    const target = e.target;

    if (!target.matches('input[type="radio"]')) {
      return;
    }

    const color = getColorFromVariantPicker();

    if (!color) {
      return;
    }

    lastColor = color;

    /*
        取消之前等待任务
      */

    if (colorTimer) {
      clearTimeout(colorTimer);

      colorTimer = null;
    }

    /*
        等 Horizon variant refresh 完成

        保留原来成功逻辑
      */

    colorTimer = setTimeout(function () {
      /*
            防止用户快速切换颜色后
            旧颜色继续执行
          */

      const currentColor = getColorFromVariantPicker();

      if (currentColor === lastColor) {
        waitAndFocusColor(color);
      }

      colorTimer = null;
    }, 1200);
  });
})();
